import i18next from 'i18next'
import { getMenuItems2 as getTranslatedMenuItems2 } from '../assets/data/menu-items'

let cachedMenuItems = null
let cachedMenuLanguage = null
let lastFetchTime = 0
const CACHE_DURATION = 30000

export const getMenuItems = async () => {
  const language = i18next.resolvedLanguage || i18next.language
  if (cachedMenuItems && cachedMenuLanguage === language && Date.now() - lastFetchTime < CACHE_DURATION) {
    return cachedMenuItems
  }

  const translatedLabel = (key, fallback) => i18next.t(key, { defaultValue: fallback })
  const finalMenu = [
    {
      key: 'oracle',
      label: translatedLabel('menu.oracle', 'Oráculo'),
      isTitle: false,
      icon: 'solar:stars-minimalistic-bold-duotone',
      url: '/oracle',
    },
    {
      key: 'live-games',
      label: translatedLabel('menu.liveMarkets', 'Live Markets'),
      isTitle: false,
      icon: 'solar:play-circle-outline',
      url: '/live',
    },
    {
      key: 'resources',
      label: translatedLabel('menu.resources', 'Recursos'),
      isTitle: false,
      icon: 'solar:widget-add-outline',
      url: '/resources',
    },
  ].filter(Boolean)

  cachedMenuItems = finalMenu
  cachedMenuLanguage = language
  lastFetchTime = Date.now()

  return finalMenu
}

export const clearMenuCache = () => {
  cachedMenuItems = null
  lastFetchTime = 0
}

export const getMenuItems2 = () => {
  return getTranslatedMenuItems2()
}

export const findAllParent = (menuItems, menuItem) => {
  let parents = []
  const parent = findMenuItem(menuItems, menuItem.parentKey)
  if (parent) {
    parents.push(parent.key)
    if (parent.parentKey) {
      parents = [...parents, ...findAllParent(menuItems, parent)]
    }
  }
  return parents
}

export const getMenuItemFromURL = (items, url) => {
  if (items instanceof Array) {
    for (const item of items) {
      const foundItem = getMenuItemFromURL(item, url)
      if (foundItem) {
        return foundItem
      }
    }
  } else {
    if (items.url === url) return items
    if (items.children != null) {
      for (const item of items.children) {
        if (item.url === url) return item
      }
    }
  }
}

export const findMenuItem = (menuItems, menuItemKey) => {
  if (menuItems && menuItemKey) {
    for (const item of menuItems) {
      if (item.key === menuItemKey) {
        return item
      }
      const found = findMenuItem(item.children, menuItemKey)
      if (found) return found
    }
  }
  return null
}
